// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__6qzdy","icon":"ThemeToggle_icon__cn1VN"};